import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledDatePicker } from '../../ControlledFields';
import {
  GridContainer,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

interface Props {
  fromFieldName?: string;
  toFieldName?: string;
}

const ValidityFormElement = ({
  fromFieldName = 'valid.from',
  toFieldName = 'valid.to'
}: Props) => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <GridContainer>
      <GridCompact6>
        <ControlledDatePicker
          fullWidth
          control={control}
          name={fromFieldName}
          variant="outlined"
          label={t('validFrom')}
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledDatePicker
          fullWidth
          control={control}
          name={toFieldName}
          variant="outlined"
          label={t('validTo')}
        />
      </GridCompact6>
    </GridContainer>
  );
};

export default ValidityFormElement;
